import React, { createContext, useEffect, useReducer, useState } from 'react';
import { Constants } from '@CONFIG';
import { useQuery } from '@HOOKS';

export const AuthContext = createContext({});

const initialState = {
  authenticated: null,
  token: localStorage.getItem(Constants.LOCAL_STORAGE_AUTH_KEY),
  info: {},
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET_TOKEN':
      localStorage.setItem(Constants.LOCAL_STORAGE_AUTH_KEY, payload);
      return {
        ...state,
        authenticated: null,
        token: payload,
      };
    case 'SET_USER':
      return {
        ...state,
        authenticated: true,
        info: {
          ...payload,
        },
      };
    case 'LOG_OUT':
      localStorage.removeItem(Constants.LOCAL_STORAGE_AUTH_KEY);
      return {
        ...state,
        info: {},
        token: null,
        authenticated: false,
      };
    default:
      break;
  }
};

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const query = useQuery();
  const [mount, setMount] = useState(false);

  useEffect(() => {
    const token = query.get('token');
    if (token && !mount) {
      localStorage.removeItem(Constants.LOCAL_STORAGE_AUTH_KEY);
      //window.history.pushState({}, document.title, window.location.pathname);
      dispatch({ type: 'SET_TOKEN', payload: token });
      setMount(true);
    } else {
      setMount(true);
    }
  }, [query, mount]);

  if (!mount) {
    return <div />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        dispatch,
        setToken: (token) => dispatch({ type: 'SET_TOKEN', payload: token }),
        // setUser: (info) => dispatch({ type: 'SET_USER', payload: info }),
        logOut: () => dispatch({ type: 'LOG_OUT' }),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
